import { render } from "./RoleListComponent.vue?vue&type=template&id=425a197e"
import script from "./RoleListComponent.vue?vue&type=script&lang=js"
export * from "./RoleListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Role/RoleListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "425a197e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('425a197e', __exports__)) {
    api.reload('425a197e', __exports__)
  }
  
  module.hot.accept("./RoleListComponent.vue?vue&type=template&id=425a197e", () => {
    api.rerender('425a197e', render)
  })

}


export default __exports__